import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class InvoiceRuleServiceClass {
    // Get list of all invoice rules
    list() {
        return BaseService.post(APIPath.invoiceRuleList, {});
    }

    // Get a single invoice rule by ID
    get(invoiceRuleId) {
        return BaseService.get(`${APIPath.invoiceRuleGet}/${invoiceRuleId}`);
    }

    // Save or Update an invoice rule
    save(ruleData) {
        // Ensure all required fields have default values to match the API contract
        const payload = {
            InvoiceRuleId: ruleData.InvoiceRuleId || 0,
            CompanyId: ruleData.CompanyId || 1, // Default to 1 if not provided
            RuleName: ruleData.RuleName || '',
            IsEnabled: ruleData.IsEnabled ?? true, // Default to true if not provided
            TriggerType: ruleData.TriggerType || 0, // Default to 0 if not provided
            FrequencyDayOfWeek: ruleData.FrequencyDayOfWeek ?? null,
            FrequencyDayOfMonth: ruleData.FrequencyDayOfMonth ?? null,
            CustomerId: ruleData.CustomerId || 0,
            TemplateId: ruleData.TemplateId || 0,
            LocationId: ruleData.LocationId ?? null,
            BillingModel: ruleData.BillingModel || 1, // Default to 1 if not provided
            FixedFeePerAudit: ruleData.FixedFeePerAudit ?? 0,
            HourlyRate: ruleData.HourlyRate ?? null,
            FlatMonthlyAmount: ruleData.FlatMonthlyAmount ?? null,
            GroupingStrategy: ruleData.GroupingStrategy || 1, // Default to 1 if not provided
            AutoSendEmail: ruleData.AutoSendEmail ?? true, // Default to true if not provided
            LastRunOn: ruleData.LastRunOn ?? null,
        }

        return BaseService.post(APIPath.invoiceRuleSave, payload);
    }

    // Delete an invoice rule
    delete(invoiceRuleId) {
        return BaseService.post(APIPath.invoiceRuleDelete, { InvoiceRuleId: invoiceRuleId });
    }
}

const InvoiceRuleService = new InvoiceRuleServiceClass();
Object.freeze(InvoiceRuleService);
export { InvoiceRuleService };
